// https://github.com/sulu/sulu-demo/pull/78/files

// @flow
import React, {Fragment} from 'react';
import {autorun, computed} from 'mobx';
import {observer} from 'mobx-react';
// import classNames from 'classnames';
// import {translate} from '../../utils/Translator';
// import {FieldTypeProps} from 'sulu-admin-bundle/types';
import {Route} from 'sulu-admin-bundle/services/Router';
//import Badge, {type BadgeOptions} from '../../containers/Badge';
// import tabsStyles from './tabs.scss';
import type {ViewProps} from 'sulu-admin-bundle/containers/ViewRenderer';
 import {ResourceTabs} from 'sulu-admin-bundle/views'; //ResourceTabs
import type {Element, Node} from 'react';

type Props<T> = {
    ...ViewProps,
    children?: (T) => Element<*> | null,
    childrenProps: T,
    header?: Node,
    routeChildren?: Array<Route>,
    selectedIndex?: number,
    title?: string,
};

//React.Component<Props<T>>
//* as RT from

@observer
class CountingRowsView<T> extends React.Component<Props<T>> {
    static defaultProps = {
        childrenProps: {},
    };

    redirectToRouteWithHighestPriorityDisposer: () => void;

    constructor(props: Props<T>) {
        super();

        this.redirectToRouteWithHighestPriorityDisposer = autorun(this.redirectToRouteWithHighestPriority);
        this.parentNode = this.parentNode.bind(this);
        //console.log("nesto", RT)
    }

    componentWillUnmount() {
        this.redirectToRouteWithHighestPriorityDisposer();
    }

    componentDidMount() {
        const targetNode = document.getElementById('observeChildren');

        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: true, subtree: true };

        //const passFn = ( ctx ) => {
             // Callback function to execute when mutations are observed
            const callback = function(mutationList, ctx) {
                // Use traditional 'for loops' for IE 11
                for (const mutation of mutationList) {
                    if (mutation.type === 'childList') {
                        console.log('A child node has been added or removed.');
                    }
                    else if (mutation.type === 'attributes') {
                        console.log(`The ${mutation.attributeName} attribute was modified.`);
                        //const parent = ctx.parentNode(mutation.target, 'td');

                    }
                }
            };
        //     return callback;
        // }
       
        //const clb  = passFn(this);
        // Create an observer instance linked to the callback function
        const observer = new MutationObserver( callback );

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        // Later, you can stop observing
        //observer.disconnect();
    }

    parentNode(root, parentStopSelector) {

        let parent ;
        const a = root;
        const els = [];

        while (a) {
            if( a.tagName == parentStopSelector.toUpperCase() ){
                return a;
            }   
            else if( a.hasAttribute('id') && a.id == parentStopSelector ){
                return a;
            }
            else if( a.hasAttribute('class') && a.classList.contains(parentStopSelector) ){
                return a;
            }
            //els.unshift(a);
            a = a.parentNode;
        }

        return a;
    }

    @computed get tabRouteWithHighestPriority(): Object {
        return this.routeChildren.reduce((prioritizedRoute, route) => {
            if (!prioritizedRoute) {
                return route;
            }

            const {
                options: {
                    tabPriority: highestTabPriority = 0,
                },
            } = prioritizedRoute;

            const {
                options: {
                    tabPriority = 0,
                },
            } = route;

            if (highestTabPriority >= tabPriority) {
                return prioritizedRoute;
            }

            return route;
        }, undefined);
    }

    @computed get routeChildren() {
        const {route, routeChildren} = this.props;

        return routeChildren || route.children;
    }

    @computed get sortedTabRoutes(): Array<Route> {
        return this.routeChildren.concat()
            .sort((childRoute1, childRoute2) => {
                const {tabOrder: tabOrder1 = 0} = childRoute1.options;
                const {tabOrder: tabOrder2 = 0} = childRoute2.options;

                return tabOrder1 - tabOrder2;
            });
    }

    redirectToRouteWithHighestPriority = (): void => {
        const {route, router} = this.props;

        if (!route.children.includes(router.route) && router.route !== route) {
            return;
        }

        if (this.sortedTabRoutes.includes(router.route)) {
            return;
        }

        if (!this.tabRouteWithHighestPriority) {
            return;
        }

        router.redirect(this.tabRouteWithHighestPriority.name, router.attributes);
    };

    

    render() {

        //console.log("nesto", RT)

        const {children, childrenProps, header, router, route, selectedIndex, title, isRootView} = this.props;

        const childComponent = children ? children(childrenProps) : null;

        const type = isRootView ? 'root' : 'nested';

        // const className = classNames(
        //     tabsStyles.tabsContainer,
        //     tabsStyles[type],
        //     {
        //         [tabsStyles.disableGap]: disableGap && !isRootView,
        //     }
        // );

        return (
            <Fragment>
                <div id="observeChildren">
                     {title && <h1>{title}</h1>}
                
                   
                    {header}
                    {childComponent}

                    <div className={"className"}>
                       some test view

                       nice, add other views in it
                    </div>

                    <div>Ovde ce da bude header</div>
                    <div>a ovde ostali view-i</div>

                </div>
               
            </Fragment>
        );
    }
}

export default CountingRowsView;